$(document).ready(function () {
    $('span.ifbi-product-table-tooltip-top').on('hover', function () {
        var viewableArea = $(window).scrollTop();
        var elementTopOffset = $(this).offset().top;
        var elementHeight = $(this).height();
        if (elementTopOffset - viewableArea < elementHeight) {
            $(this).removeClass('ifbi-product-table-tooltip-top');
            $(this).addClass('ifbi-product-table-tooltip-bottom');
        }
    });

    $('.ifbi-product-table-tooltip').on('hover', function () {
        if ($(this).children('span').hasClass('ifbi-product-table-tooltip-bottom')) {
            var viewableArea = $(window).scrollTop();
            var elementTopOffset = $(this).children('span').offset().top;
            var elementHeight = $(this).children('span').height();
            if (elementTopOffset - viewableArea > elementHeight) {
                $(this).children('span').addClass('ifbi-product-table-tooltip-top');
                $(this).children('span').removeClass('ifbi-product-table-tooltip-bottom');
            }
        }
    });

});